'use strict';

var _ = require('lodash');
var MarketProductGroupMappedBookingsTransformerFactory = function MarketProductGroupMappedBookingsTransformerFactory(DataTransformer) {
  function MarketProductGroupMappedBookingstTransformer(targetType, priority) {
    DataTransformer.call(this);
    this.sourceType = 'market-product-group-mapped-bookings';
    this.targetType = targetType;
    this.priority = priority || 0;
  }
  MarketProductGroupMappedBookingstTransformer.prototype = Object.create(DataTransformer.prototype);
  MarketProductGroupMappedBookingstTransformer.constructor = MarketProductGroupMappedBookingstTransformer;
  MarketProductGroupMappedBookingstTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  MarketProductGroupMappedBookingstTransformer.prototype.isCacheable = function () {
    return true;
  };
  MarketProductGroupMappedBookingstTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  MarketProductGroupMappedBookingstTransformer.prototype.transform = function (data) {
    return _.get(data, 'domain.aggregatedTripBookings', []);
  };
  return MarketProductGroupMappedBookingstTransformer;
};
MarketProductGroupMappedBookingsTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = MarketProductGroupMappedBookingsTransformerFactory;